import { Contexto } from 'src/app/asistente-en-linea/models/contexto';

export class EnviarMensajeRequest {

    public mensaje: string;

    public context: Contexto;

}